import { render } from "./multi-card-result.vue?vue&type=template&id=b6c03b86&scoped=true&ts=true"
import script from "./multi-card-result.vue?vue&type=script&lang=ts"
export * from "./multi-card-result.vue?vue&type=script&lang=ts"

import "./multi-card-result.vue?vue&type=style&index=0&id=b6c03b86&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c03b86"]])

export default __exports__